import type { ImageLabelProps } from 'src/components/atoms/ImageLabel/ImageLabel';
import { IconType, ImageLabelColor } from 'src/components/atoms/ImageLabel/ImageLabel';
import type { ProductState } from 'src/redux/product/types';

export const useImageLabel = ({
  attributes,
  availability,
  available,
  isNew,
  purchasable,
  salePercentage = 0,
}: ProductState): ImageLabelProps | null => {
  if (!available && availability === 'suspended') {
    return {
      color: ImageLabelColor.Grey,
      text: 'UNAVAILABLE',
    };
  }

  if (!purchasable) {
    return {
      color: ImageLabelColor.Grey,
      text: 'OUT OF STOCK',
    };
  }

  if (salePercentage && salePercentage > 0) {
    return {
      color: ImageLabelColor.Red,
      text: `${salePercentage}% OFF`,
    };
  }

  if (isNew) {
    return {
      color: ImageLabelColor.Green,
      text: 'NEW IN',
    };
  }

  if (attributes?.highlyRated) {
    return {
      color: ImageLabelColor.Purple,
      icon: IconType.Crown,
      text: 'MOST LOVED',
    };
  }

  if (attributes?.starBrand) {
    return {
      color: ImageLabelColor.Purple,
      icon: IconType.Diamond,
      text: 'TOP BRAND',
    };
  }

  return null;
};
